import React from 'react';
import { Link } from 'react-router-dom';

export default function ProjectDetails({ projects }) {
  return (
    <div className="flex flex-col flex-wrap justify-between">
      {projects.map(project => (
        <Link key={project.id} to={`/project/${project.id}`}>
          <div className="bg-navys-100 shadow-lg h-fit mb-10 rounded-lg py-5 px-2 font-inter md:px-4 hover:scale-110 transition duration-500 ease-linear">
            <h3 className="mb-3 text-ash-200 text-xl md:text-2xl font-bold">
              {project.title}
            </h3>
            <p className="text-ash-100 text-xl mb-3  md:leading-6">
              {project.intro.substring(0, 200)} ...
            </p>
            <ul className="flex flex-wrap w-fit font-monoBody text-accent items-center leading-8 px-3 text-xl">
              {project.stack.map((lang, i) => (
                <li key={i} className="mr-3">
                  {lang}
                </li>
              ))}
            </ul>
          </div>
        </Link>
      ))}
    </div>
  );
}
